import { render, staticRenderFns } from "./SearchResultUser.vue?vue&type=template&id=e21aac42&"
import script from "./SearchResultUser.vue?vue&type=script&lang=js&"
export * from "./SearchResultUser.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports